import { type PropsWithChildren } from "react";

import { cx } from "../cx";

interface HeaderProps extends PropsWithChildren {
  className?: string;
}

export const Header = ({ children, className }: Readonly<HeaderProps>) => (
  <header
    data-testid="circle-ai-shell-workspace-header"
    className={cx("shrink-0", className)}
  >
    {children}
  </header>
);

Header.displayName = "CircleAIAppShell.Layout.Workspace.Header";
